import React from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import { CookiesProvider } from 'react-cookie';

import Main from './Main';
import Task from './Task';
import APIReference from './APIReference';
import About from './About';

function AppRouter() {
  return (
    <CookiesProvider>
      <Router>
        <Route path="/" exact component={Main} />
        <Route path="/task/:id/" component={Task} />
        <Route path="/reference/" component={APIReference} />
        <Route path="/about/" component={About} />
      </Router>
    </CookiesProvider>
  );
}

export default AppRouter;